
import { RootState } from "@/store/store";
import axios from "axios";
import { X } from "lucide-react";
import logoAR from "../../../public/logos/logo-ar.png"
import logoEN from "../../../public/logos/logo-en.png"
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
export default function WhatsNew({ setShowUpdates }: { setShowUpdates: React.Dispatch<React.SetStateAction<boolean>> }) {
    const updates = useSelector((state: RootState) => state.updates.updates);
    const { t } = useTranslation();
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const baseUrl = import.meta.env.VITE_BASE_URL
    const formatTimestamp = (timestamp: number): string => {
        const date = new Date(timestamp * 1000);
        return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // Use 12-hour format
        }).format(date);
    };

    const fullAttachmentUrl = updates?.attachment
        ? updates.attachment.startsWith("http")
            ? updates.attachment
            : `${baseUrl}/${updates.attachment}`
        : null;

    async function confirmUpdates() {
        setShowUpdates(false)
        const options = {
            url: `${baseUrl}/api/dashboard/users/mark-as-updated`,
            method: "POST",
            headers: {
                Authorization: token,
            },
        }
        await axios.request(options)

    }
    return (
        <>
            <div onClick={() => {
                confirmUpdates()
                setShowUpdates(false)
            }} className="fixed inset-0 z-[999999] p-5 flex items-center justify-center bg-black bg-opacity-50">
                <div onClick={(e) => e.stopPropagation()} className="bg-white pt-14 min-w-[350px]  pb-5 px-5 rounded-3xl relative  ">
                    <div><X onClick={() => {
                        confirmUpdates()
                        setShowUpdates(false)
                    }} className="cursor-pointer absolute top-3 text-red-500 right-3 z-[999999]" /></div>
                    <div className=" flex justify-center items-center gap-5">
                        <div className="flex justify-center bg-sidebar w-[100px] px-2 py-2 rounded-md">
                            <img src={t(logoEN, logoAR) as string} alt="" />
                        </div>
                        {/* <div className="text-sm font-semibold bg-sidebar text-skyblue p-1 self-end rounded-md">
                            V.{updates?.version}
                        </div> */}
                    </div>

                    <div className="flex flex-col my-10 items-center mb-2">
                        <h3 className=" text-sidebar m-0 font-semibold text-center">{t("whatsNews.title")}</h3>
                        <p className=" text-sidebar font-semibold">{t(updates.contentEN, updates.contentAR)}</p>
                    </div>

                    <div className="my-3 flex justify-center">
                        {fullAttachmentUrl ? (
                            fullAttachmentUrl.endsWith(".pdf") ? (
                                <embed
                                    src={fullAttachmentUrl}
                                    type="application/pdf"
                                    className="w-full h-[400px] border rounded-md"
                                />
                            ) : (
                                <img
                                    src={fullAttachmentUrl}
                                    alt="Update Attachment"
                                    className="max-w-full max-h-[300px] rounded-md border"
                                />
                            )
                        ) :""
                        }


                    </div>

                    <div className="flex flex-col items-center  my-5 ">

                        <span className="text-gray-500">{formatTimestamp(updates?.release)}</span>
                    </div>

                    <div className="mx-auto w-full">
                        <button onClick={confirmUpdates} className="my-btn px-5 py-2">{t("whatsNews.close")}</button>
                    </div>
                </div>
            </div>


        </>
    )
}
